// extracted by mini-css-extract-plugin
export var blankIndustry = "content-preview-row-module--blank-industry--ffbc1";
export var copy = "content-preview-row-module--copy--c2b0f";
export var copyWrapper = "content-preview-row-module--copyWrapper--0c659";
export var description = "content-preview-row-module--description--a675b";
export var favorite = "content-preview-row-module--favorite--a3dc2";
export var imageWrapper = "content-preview-row-module--imageWrapper--67200";
export var industryImage = "content-preview-row-module--industry-image--75fd4";
export var linkIndustry = "content-preview-row-module--link-industry--f3b23";
export var linkTitle = "content-preview-row-module--link-title--ac1ac";
export var primaryImage = "content-preview-row-module--primary-image--b8ba8";
export var root = "content-preview-row-module--root--e8de2";
export var tags = "content-preview-row-module--tags--625a2";
export var title = "content-preview-row-module--title--7a0a2";